import Phaser from 'phaser';

/* eslint-disable no-param-reassign */
// taken from CreateJS's BitmapData code
export function floodFill (x, y, color, context) {
  const imgData = context.getImageData(0, 0, context.canvas.width, context.canvas.height);
  const w = imgData.width;
  const h = imgData.height;
  x = x >> 0;
  y = y >> 0;
  if (x < 0 || y < 0 || w <= x || h <= y) {
    return;
  }
  const targetColor = getPixel32(x, y, imgData);
  if (targetColor === color) {
    return;
  }
  const d = imgData.data;
  const buffer = [new Phaser.Geom.Point(x, y)];
  while (buffer.length) {
    const p = buffer.shift();
    const px = p.x;
    const py = p.y;
    if (getPixel32(px, py, imgData) === color) {
      continue;
    }
    let xl = px;
    for (xl = px; 0 < xl; xl--) {
      if (getPixel32(xl - 1, py, imgData) !== targetColor) {
        break;
      }
    }
    let xr = px;
    for (xr = px; xr < w - 1; xr++) {
      if (getPixel32(xr + 1, py, imgData) !== targetColor) {
        break;
      }
    }
    for (let i = xl; i <= xr; i++) {
      setPixel32(i, py, color, imgData);
    }
    if (py + 1 < h) scanLine(xl, xr, py + 1, targetColor, buffer, imgData);
    if (0 <= py - 1) scanLine(xl, xr, py - 1, targetColor, buffer,imgData);
  }
  context.putImageData(imgData, 0, 0);
}

function getPixel32 (x, y, imgData) {
  if (x < 0 || y < 0) {
    return 0;
  }
  x = x >> 0;
  y = y >> 0;

  const w = imgData.width;
  const h = imgData.height;
  if (w <= x || h <= y) {
    return 0;
  }
  const d = imgData.data;
  let i = ((w * y) + x) * 4;
  const r = d[i];
  const g = d[++i];
  const b = d[++i];
  const a = d[++i];
  return (a << 24 | r << 16 | g << 8 | b) >>> 0;
}

function setPixel32 (x, y, color, imgData) {
  if (x < 0 || y < 0) {
    return;
  }
  x = x >> 0;
  y = y >> 0;
  const w = imgData.width;
  const h = imgData.height;
  if (w <= x || h <= y) {
    return;
  }
  const d = imgData.data;
  let i = ((w * y) + x) * 4;
  d[i] = color >> 16 & 0xFF;
  d[++i] = color >> 8 & 0xFF;
  d[++i] = color & 0xFF;
  d[++i] = color >> 24 & 0xFF;
}

function scanLine(xl, xr, y, targetColor, buffer, imgData) {
  while (xl <= xr) {
    while (xl <= xr) {
      if (getPixel32(xl, y, imgData) === targetColor) {
        break;
      }
      xl++;
    }
    if (xr < xl) {
      break;
    }
    xl++;
    while (xl <= xr) {
      if (getPixel32(xl, y, imgData) !== targetColor) {
        break;
      }
      xl++;
    }
    buffer.push(new Phaser.Geom.Point(xl - 1, y));
  }
}